/*
  Function receive container size in px and reduce closest biggest size value from sizeList
 */
export var getSizePoint = function getSizePoint(containerSize) {
  var sizeList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return sizeList.reduce(function (acc, current) {
    return containerSize > acc.size ? current : acc;
  }, sizeList[0]);
};
export default {
  getSizePoint: getSizePoint
};